import React, {InputHTMLAttributes} from 'react'

const HiddenFileInput = React.forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>((props, ref) => {
    return <input hidden type="file" ref={ref} {...props} />
})

export {HiddenFileInput}
